import style from './Form.module.scss'
import DatePicker from './DateRangePicker'

export * from './DateRangePicker'

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 */
export const Form = ({ children, className }) => {
  return <form className={cn(style['form'], className)}>{children}</form>
}

/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 */
export const FormHeader = ({ children, className }) => <h2 className={cn(style['form-header'], className)}>{children}</h2>

/** @param {import('./Form.types').FormItemProps} props */
export const FormItem = ({ children, className, label, inline }) => (
  <div className={cn(style['form-item'], inline ? style['inline'] : '', className)}>
    {label && <label>{label}</label>}
    {children}
  </div>
)

/**
 * @param {import('./Form.types').FormTextProps} props
 */
export const FormText = ({ value, onChange, type = 'text', placeholder = '', ...itemProps }) => (
  <FormItem {...itemProps}>
    <input type={type} value={value || ''} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} />
  </FormItem>
)

/**
 * @template T={label: string, value: string}
 * @param {import('./Form.types').FormSelectProps<T>} props
 */
export const FormSelect = ({ label, className, inline, ...selectProps }) => (
  <FormItem className={cn(style['form-select'], className)} label={label} inline={inline}>
    <div className={style['select-wrapper']}>
      <SelectInput {...selectProps} />
    </div>
  </FormItem>
)

/**
 * @template [T={label: string, value: string}]
 * @param {import("./Form.types").SelectInputProps<T>} props */
const SelectInput = ({
  items,
  value = '',
  // @ts-expect-error Default template type
  // TODO: Fix
  getItemLabel = (item) => item.label,
  // TODO: Fix
  // @ts-expect-error Default template type
  getItemValue = (item) => item.value,
  onSelect,
  placeholder
}) => {
  const options = items.map((item) => ({
    label: getItemLabel(item),
    value: getItemValue(item)
  }))

  return (
    <select value={value} onChange={(e) => onSelect(e.target.value)}>
      {placeholder && (
        <option value='' disabled>
          {placeholder}
        </option>
      )}
      {options.map(({ label, value }) => (
        <option key={`${label}-${value}`} value={value}>
          {label}
        </option>
      ))}
    </select>
  )
}

/** @param {import('./Form.types').FormCheckboxProps} props */
export const FormCheckbox = ({ label, checked, onChange }) => {
  return (
    <FormItem className={cn(style['form-checkbox'], style['inline-reverse'])} label={label}>
      <input type='checkbox' checked={checked} onChange={(e) => onChange(e.target.checked)} />
    </FormItem>
  )
}

/** @param {import('./Form.types').TimestampFilterInputProps} props */
export const TimestampFilterInput = ({ value, onChange, label }) => {
  /** @param {number | null} from */
  const handleFromChange = (from) => onChange({ ...value, from })
  /** @param {number | null} to */
  const handleToChange = (to) => onChange({ ...value, to })

  /**
   * Converts a date input value (yyyy-MM-dd) to a local timestamp at the given time
   * @param {string} date
   * @param {string} time
   * @returns {number | null}
   */
  const toTimestamp = (date, time) => (date ? new Date(`${date}T${time}`).getTime() : null)

  return (
    <FormItem className={style['date-picker']} label={label}>
      <div style={{ marginTop: 10 }}>
        <DatePicker from={value.from} to={value.to} onChangeFrom={(e) => handleFromChange(toTimestamp(e.target.value, '00:00:00'))} onChangeTo={(e) => handleToChange(toTimestamp(e.target.value, '23:59:59.999'))} />
      </div>
    </FormItem>
  )
}

/** @param {...(string | undefined)} classes */
const cn = (...classes) => {
  return classes.filter(Boolean).join(' ')
}
